module.exports = __webpack_public_path__ + "img/time-gray-icon.b9f9aca5.svg";